export const environment = {
  production: false,
  url: 'https://api.analise.people.test.private.unico.run',
  base_url: 'https://analysis.people.test.private.unico.run',
  identity_url: 'https://identityqa.acesso.io',
  cookie_url: 'https://admin.people.test.private.unico.run/svc2/authorize',
  people_url: 'https://admin.people.test.private.unico.run/svc2',
  launchDarklyClientId: "63b870113b5a4212abb0f0fa",
  sentry: {
    dsn: 'https://02edf4cbf66b4aa7aca1a8da6c2de95b@o910534.ingest.us.sentry.io/5845262',
    tracesSampleRate: 1.0,
    traceOrigin: [
      "https://analysis.people.test.private.unico.run/*",
      "https://api.analise.people.test.private.unico.run/*",
      "https://svc.people.test.private.unico.run/authorize",
      "https://admin.people.test.private.unico.run/svc2/tools/customer-data/track"
    ]
  },
  mixpanel: {
    token: 'f4069d9b550ea08e34089810c2abd5be',
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
  },
  mock: false,
};
